import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
// Imports (assuming these paths are correct in your project)
import shingle from '../../../assets/ColumbusPage/Residential Roof/Shingle_Roofing_Contactor_Columbus_Ohio_Ultimatesroofing.jpg';
import metal from '../../../assets/ColumbusPage/Residential Roof/Metal_Roofing_Contactor_Columbus_Ohio_Ultimatesroofing.jpg';
import repair from '../../../assets/ColumbusPage/Residential Roof/Roof_Repair_Columbus_Ohio_Ultimatesroofing.jpg';
import storm from '../../../assets/ColumbusPage/Residential Roof/Storm_Damage_Columbus_oho.jpg';
import gutters from '../../../assets/ColumbusPage/Residential Roof/Gutters_&_Siding_Columbus_Ultimatesroofing.jpg';
import replacement from '../../../assets/ColumbusPage/Residential Roof/Roof_Replacement_neare_me.jpg';

import '../all/Main.css';
import './ResidentialRoofing.css';

import View from './View'; // Re-added
import Badge from '../ServiceSection/Badge';
import { Link } from 'react-router-dom';

const SERVICES = [
  { title: "Shingle Roofing", description: "Affordable, attractive shingles engineered for Ohio weather durability and lifespan.", image: shingle },
  { title: "Metal Roofing", description: "Energy-efficient metal roofing offering exceptional longevity and storm resistance.", image: metal },
  { title: "Roof Repair", description: "Targeted residential roof repairs preventing leaks and interior damage.", image: repair },
  { title: "Storm Damage", description: "Residential storm restoration after hail, wind, and heavy rain events.", image: storm },
  { title: "Gutters & Siding", description: "Complete gutter and siding solutions protecting homes from water intrusion.", image: gutters },
  { title: "Roof Replacement", description: "Full residential roof replacement enhancing safety, value, and curb appeal.", image: replacement }
];

const COLORS = {
  primary: '#3D3B6D',
  accent: '#b22335',
  cardBg: '#ffffff',
  border: '#e8e8ef',
  overlay: 'rgba(61, 59, 109, 0.65)'
};

const ServiceCard = ({ service, index }) => {
  const isEven = index % 2 === 0;
  return (
    <motion.div
      initial={{ y: 80, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }} 
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.7, delay: index * 0.1 }}
      className="h-100 d-flex flex-column w-100"
    >
      <div
        className="res-card h-100 position-relative overflow-hidden d-flex flex-column"
        style={{
          borderRadius: '16px', 
          backgroundColor: COLORS.cardBg,
          border: `1px solid ${COLORS.border}`
        }}
      >
        <div className="position-relative overflow-hidden flex-shrink-0" style={{ height: '240px' }}>
          <img src={service.image} alt={service.title} className="w-100 h-100" style={{ objectFit: 'cover' }} />
          
          <div className="res-badge-wrap ">
            <span className="res-badge d-flex  justify-content-lg-start justify-content-center" style={{ backgroundColor: isEven ? COLORS.accent : COLORS.primary }}>
              Residential
             
            </span>
          </div>

          <div className="position-absolute top-0 start-0 w-100 h-100"
           style={{ background: `linear-gradient(180deg, ${COLORS.overlay} 0%, rgba(26,26,46,.25) 60%, rgba(26,26,46,.5) 100%)` }} />
        </div>
        
        <div className="p-4 d-flex flex-column flex-grow-1">
          <h3 className="text-start m-0 mb-2 res-card-title" style={{ color: COLORS.primary }}>{service.title}</h3>
          <p className="res-card-desc text-start flex-grow-1">{service.description}</p>
         
          <Link to="/residential-roofing" className="res-card-link d-flex justify-content-start mt-auto">
            Learn More <i className="bi bi-arrow-right ms-2" />
          </Link>
        </div>
        <div className="res-card-footer-line" style={{ background: `linear-gradient(90deg, ${isEven ? COLORS.accent : COLORS.primary}, transparent)` }} />
      </div>
    </motion.div>
  );
};

const ResidentialRoofing = () => (
  <section className="cs-section residential-section">
    <Container>
      <div>
        {/* Header with View component */} 
        <div className="d-flex justify-content-between align-items-start flex-wrap">
            <div>
                {/* badge and title  */}
                <div className='cs-badge d-flex justify-content-lg-start justify-content-center'>
        <Badge text="Residential Roofing"></Badge>
        </div>
                <h2 className="cs-title residential-title text-lg-start text-center"> Columbus Residential 
                  <span  style={{ fontWeight: '500',}} >  Roofing Solutions</span></h2>

                <p className="cs-desc residential-desc text-lg-start">We provide reliable 
                  residential roofing solutions in Columbus, helping homeowners
                   protect their families and ensure long-lasting performance.</p>
            </div>
            <div className="mt-2">
                <View />
            </div>
        </div>
      </div>
      <Row className="g-4 cs-content">
        {SERVICES.map((service, index) => (
          <Col lg={4} md={6} key={index} className="d-flex flex-column">
            <ServiceCard service={service} index={index} />
          </Col>
        ))}
      </Row>
    </Container>
  </section>
);

export default ResidentialRoofing;